export default __webpack_public_path__ + "static/escola-sem-cantina-10c5518527cb7e202a06f83c21ed0f0d.png";